import React, { Component } from 'react';

import Regions from './RegionsComponent'
import { actions } from './RegionsReducer'
import { connect } from 'react-redux'



class Wrapper extends Component {
    componentDidMount() {
        this.props.fetch();
    }
    
    render() {
        return (
            <React.Fragment>
                <Regions {...this.props} />                
            </React.Fragment>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        regions: state.waas.regions.regions.items || [],
        regionsPanels: state.waas.regions.regions.regionsPanels || [],
        regionsErrors: state.waas.regions.regions.regionPanelsWarningErrors || {},
        regionsAppCount: state.waas.regions.regions.regionsAppCount || {},
        shouldUpdate: state.waas.regions.regions.shouldUpdate,
        isLoading: state.waas.regions.regions.isLoading,
    }
}

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        toggleRegionPanel: (payload) => dispatch(actions.togglePanel(payload)),
        expandAll: () => dispatch(actions.expandAll()),
        collapseAll: () => dispatch(actions.collapseAll()),
        setShouldUpdate: (value) => dispatch(actions.setShouldUpdate(value)),
        fetch: () => dispatch(actions.fetchRegions()),
        reload: () => { dispatch(actions.fetchRegions())},
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Wrapper)